import { createStore } from 'vuex'

import theme from './modules/theme'
import moduleInit from './modules/init'
import botSetting from './modules/botSetting'
import chat from './modules/chat'
import botProfile from './modules/botProfile'
import report from './modules/report'
import mailing from './modules/mailing'
import ReportFromBuilder from './modules/ReportFromBuilder'
import projects from './modules/projects'

const store = createStore({
    modules: {
        theme: theme,
        init: moduleInit,
        botSetting: botSetting,
        chat,
        botProfile,
        report,
        mailing,
        ReportFromBuilder,
        projects
    },
    strict: process.env.NODE_ENV !== 'production'
});

store.dispatch('init/init').then(() => {}).catch(() => {});

export default store

